import { fork } from "redux-saga/effects";
import authSaga from "./auth";
import onboardingSaga from "./onboarding";
import userSaga from "./user";
import adminSaga from "./admin";
import ticketsSaga from "./tickets";
import projectSaga from "./projects";
import walletSaga from "./wallet"
import ccsSaga from "./ccs"
export default function* indexSaga() {
    yield fork(authSaga)
    yield fork(onboardingSaga)
    yield fork(userSaga)
    yield fork(adminSaga)
    yield fork(ticketsSaga)
    yield fork(projectSaga)
    yield fork(walletSaga)
    yield fork(ccsSaga)
}